import { Container } from "./MessagesStyle";
import Spinner from "../../shared/Spinner/Spinner";
import Message from '../Message/MessageBubble';
import MessageAnnex from '../Message/MessageAnnexBubble';
import api from "../../services/api";
import { IoSend, IoAttach } from 'react-icons/io5';
import { useEffect, useState } from "react";
import { AxiosRequestConfig } from "axios";
import { Plugins } from '@capacitor/core';
import PageTitle from "../../components/PageTitle";


const { Modals } = Plugins;

export default function Messages(props) {
  const [userName, setUserName] = useState("");
  const [messages, setMessages] = useState([] as any);

  const [loading, setLoading] = useState(false);
  const [sendingMessage, setSendingMessage] = useState(false);
  const [messageSending, setMessageSending] = useState("");

  const [fileAttached, setFileAttached] = useState({} as File);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [uploadingFile, setUploadingFile] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const userId = props.match.params.userId;

  useEffect(() => {
    console.debug("Pegando mensagens");
    setLoading(true);
    LoadMessages().then(() => setLoading(false));
    const updateMessageIntervalID = setInterval(LoadMessages, 10000);

    return () => {
      console.debug("Parando atualização das mensagens");
      clearInterval(updateMessageIntervalID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  function GoBack() {
    props.history.goBack();
  }

  async function LoadMessages() {
    try {
      console.debug("Atualizando mensagens");
      const response = await api.get(`messages/admin?userId=${userId}`);
      setErrorMessage("");
      setMessages(response.data.messages);
      setUserName(response.data.userName);
      await MarkMessageAsRead();
    }
    catch (error) {
      setErrorMessage("Não foi possível se conectar com o servidor!");
    }
  }

  async function SendMessage() {
    try {
      setSendingMessage(true);
      const response = await api.post(`messages/toUser`, { userId, message: messageSending });
      if (response.data.success) {
        setMessageSending("");
        setErrorMessage("");
      }
      else
        setErrorMessage("Não foi possível enviar mensagem!");
      setSendingMessage(false);
      LoadMessages();
    }
    catch (error) {
      console.error(error);
      setErrorMessage("Não foi possível enviar mensagem por problemas na conexão!");
      setSendingMessage(false);
    }
  }

  async function SendMessageFileAttached(file) {

    try {
      const options: AxiosRequestConfig = {};
      const formData = new FormData();

      console.debug("Arquivo para enviar:", file);
      formData.append("userId", userId);
      formData.append("attachment", file, file.name);
      options.onUploadProgress = progressEvent => {
        const { loaded, total } = progressEvent;
        const percentage = Math.floor(loaded * 100 / total);
        setUploadPercentage(percentage);
        console.debug(`${loaded}kb de ${total}kb | ${percentage}% carregados`);
      }

      setUploadingFile(true);
      setSendingMessage(true);
      setLoading(true);

      const result = await api.post("/messages/attachmentToUser", formData, options);
      console.debug(result);
      await LoadMessages();

      setUploadingFile(false);
      setSendingMessage(false);
      setLoading(false);
    }
    catch (error) {
      setUploadingFile(false);
      setSendingMessage(false);
      setLoading(false);
      setErrorMessage("Não foi possível enviar o arquivo");
      console.error(error);
    }
  }

  async function MarkMessageAsRead() {
    try {
      await api.put(`messages/readCompany`, { userId });
      setErrorMessage("");
    }
    catch (error) {
      setErrorMessage("Não foi possível se conectar com o servidor!");
    }
  }

  function OnKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      SendMessage();
    }
  }

  function ChangeFileAttached(event) {
    console.debug("Alterando arquivo anexo");
    const file = event.target.files[0];
    OnAnnexFile(file);
  };

  async function OnAnnexFile(file: File) {
    const confirm = await Modals.confirm({
      title: 'Enviar arquivo?',
      message: `Enviar arquivo "${file.name}"?`,
      okButtonTitle: "Sim",
      cancelButtonTitle: "Cancelar",
    });

    if (confirm.value) {
      setFileAttached(file);
      SendMessageFileAttached(file);
    }
    else
      setFileAttached({} as File);
  }

  return (
    <Container>
      <PageTitle title="Mensagem" />
      <main>
        <section>
          <button onClick={GoBack} className="btn btn-secondary">Voltar</button>
          <h2>{loading ? "Carregando" : userName !== "" ? userName : "Usuário"}</h2>
        </section>
        {errorMessage !== "" && <h1 className="alert"> {errorMessage}</h1>}
        <Spinner spinning={loading} />

        <div id="messages-area">
          {
            messages?.length > 0 && messages.map((message, index) => {
              if (!message.attachmentUrl)
                return (<Message key={parseInt(message.id)} left={message.userSent} text={message.message} date={message.date} />)
              else
                return (<MessageAnnex key={parseInt(message.id)} message={message} />)
            })
          }
          {sendingMessage && !fileAttached && <Message key={-1} left={false} text={messageSending} sending={true} date={Date.now()} />}
          {uploadingFile && <MessageAnnex key={-1} message={{
            attachmentName: fileAttached.name,
            userSent: false,
            sending: true,
            date: Date.now(),
            uploadProgress: uploadPercentage,
          }} />
          }
        </div>
        <div id="input-area">
          <label htmlFor="attachFileInput" id="attachFileLabel">
            <IoAttach />
          </label>
          <input
            id="attachFileInput"
            autoComplete="message-attachment"
            disabled={sendingMessage}
            type="file"
            name="attachment"
            value={""}
            onChange={ChangeFileAttached} />
          <input
            type="text"
            id="message-input"
            autoComplete="off"
            value={messageSending}
            disabled={sendingMessage}
            onKeyDown={e => OnKeyDown(e)}
            onChange={e => setMessageSending(e.target.value)} />

          <button id="send-message" disabled={sendingMessage || messageSending?.length === 0} onClick={e => SendMessage()}>
            <IoSend />
          </button>
        </div>
      </main>
    </Container >
  );
}